var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner-1",style:({ color: this.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }